//ghj
import "@/utils/system.js"; //公共JS代码

//转换
export var converterEx = {
	toMoney: function(value) {
		return typeof value == "number" ? value.toFixed(2) : "";
	},
	toDateTime: function(value) {
		if (!value) return null;
		if (typeof value != "string") return null;
		if (value.length < 19) return null;
		return new Date(value.substr(0, 4), value.substr(5, 2) - 1, value.substr(8, 2), value.substr(11, 2),
			value
			.substr(14, 2), value.substr(17, 2));
	},
	toDateString: function(value) {
		var dateTime = converterEx.toDateTime(value);
		return dateTime ? dateTime.toStringEx("yyyy-MM-dd") : "";
	},
	toDateTimeString: function(value) {
		var dateTime = converterEx.toDateTime(value);
		return dateTime ? dateTime.toStringEx("yyyy-MM-dd HH:mm") : "";
	},
	toDateTime2String: function(value,DateStr) {
		var dateTime = converterEx.toDateTime(value);
		var result= dateTime ? dateTime.toStringEx("yyyy-MM-dd HH:mm") : "";
		return result.replace(DateStr,"");
	},
	
	toStringTime: function(value) {
		var dateTime = converterEx.toDateTime(value);
		return dateTime ? dateTime.toStringEx("HH:mm") : "";
	},
	toTimeString: function(value) {
		return value.hours.toString().padLeftEx(2, "0") + ":" + value.minutes.toString().padLeftEx(2, "0")
	},
	toStringEx: function(value, format) {
		format = format.replace("yyyy", value.getFullYear());
		format = format.replace("MM", (value.getMonth() + 1).toString().padLeftEx(2, "0"));
		format = format.replace("dd", value.getDate().toString().padLeftEx(2, "0"));
		format = format.replace("HH", value.getHours().toString().padLeftEx(2, "0"));
		format = format.replace("mm", value.getMinutes().toString().padLeftEx(2, "0"));
		format = format.replace("ss", value.getSeconds().toString().padLeftEx(2, "0"));
		return format;
	},
	getKey: function(value) {
		if (value == undefined || value == null || value == "") return null;
		else return value.key;
	}
}

/**
 * 判断是否为空
 * @param {值} value 
 */
export function isNullOrEmptyEx(value) {
	if (value == undefined || value == null || value == "") return true;
	else return false;
}
